import { describeFields, FieldWidget } from '../common/fields';
import { StreamSchema } from './schemas';

export const STREAM_FIELDS = describeFields(StreamSchema, {
  courseId: {},
  id: {},
  groupCode: {},
  scheduleLink: {},
  basePermissionIds: {},
  gradYear: {},
  groupName: {},
  type: {},
  priceId: { widget: FieldWidget.Select },
  slackChannels: {},
  separatelyBilled: { widget: FieldWidget.Text },
  active: {},
  orderedLessonTemplateCodes: {},
});
